"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReorderListItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactDnd = require("react-dnd");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ReorderListItem(_ref) {
  var children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    i = _ref.i,
    items = _ref.items,
    moveListItem = _ref.moveListItem,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var ref = (0, _react.useRef)(null);
  var _useDrop = (0, _reactDnd.useDrop)({
      accept: 'drag',
      hover(item, monitor) {
        var _ref$current;
        if (!ref.current) {
          return;
        }
        var dragIndex = item.i;
        var hoverIndex = i;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
          return;
        }

        // Determine rectangle on screen
        var hoverBoundingRect = (_ref$current = ref.current) == null ? void 0 : _ref$current.getBoundingClientRect();
        // Get vertical middle
        var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        var clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        var hoverClientY = clientOffset.y - hoverBoundingRect.top;

        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%

        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
          return;
        }

        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
          return;
        }

        // Time to actually perform the action
        moveListItem(dragIndex, hoverIndex, items);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive i searches.
        // eslint-disable-next-line no-param-reassign
        item.i = hoverIndex;
      }
    }),
    _useDrop2 = (0, _slicedToArray2.default)(_useDrop, 2),
    drop = _useDrop2[1];
  var _useDrag = (0, _reactDnd.useDrag)({
      collect: function collect(monitor) {
        return {
          isDragging: monitor.isDragging()
        };
      },
      item: {
        i,
        id,
        type: 'drag'
      }
    }),
    _useDrag2 = (0, _slicedToArray2.default)(_useDrag, 2),
    drag = _useDrag2[1];
  drag(drop(ref));
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: className,
    id: id,
    style: (0, _extends2.default)({}, style)
  }, /*#__PURE__*/_react.default.createElement("div", {
    onDropCapture: function onDropCapture(e) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, children));
}